/**
 * 결제 결과 페이지 라우트
 * FSD: pages/payment-result
 */

import { RouteObject } from 'react-router-dom';
import PaymentResultPage from './ui/PaymentResultPage';

export const paymentResultRoute: RouteObject = {
  path: '/payment/result',
  element: <PaymentResultPage />,
};
